<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista Avaliação de Onboardings'" :showBtn="failRequest" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhuma avaliação de onboarding encontrada.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <p class="media-nps">{{ averange }}</p>
                    <span
                      class="caption-subject font-blue bold uppercase right">Quantidade total de avaliações ({{ dataList.length }})</span>
                  </div>
                </div>

                <p>Deixa o mouse sobre as Pergunta 1 etc.. para visualizar o valor da pergunta.</p>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th data-toggle="tooltip" title="Todas suas dúvidas foram respondidas?" class="cursor">PERGUNTA
                          1
                        </th>
                        <th data-toggle="tooltip"
                            title="O quanto você se sente seguro para navegar no sistema depois do treinamento?"
                            class="cursor"> PERGUNTA 2
                        </th>
                        <th data-toggle="tooltip" title="Qual sua nota para a atendente que realizou a apresentação?"
                            class="cursor"> PERGUNTA 3
                        </th>
                        <th data-toggle="tooltip" title="Qual sua nota para a apresentação realizada?" class="cursor">
                          PERGUNTA 4
                        </th>
                        <th> MENSAGEM</th>
                        <th> RESPONDIDO EM</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataList">
                        <td>
                          <a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contextCode" target="_blank"
                             class="link">{{ c.companyName }}</a>
                        </td>
                        <td>
                          <span v-if="c.onboardingAllQuestionWasAnswered">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                        <td>{{ c.onboardingSafeRating }}</td>
                        <td>{{ c.onboardingAttedentRating }}</td>
                        <td>{{ c.onboardingApresentationRating }}</td>
                        <td>{{ c.onboardingMessage }}</td>
                        <td>{{ c.date }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  GET_RATING_ONBOARDINGS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "listEvaluationOnboarding",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loadingList: false,
      failRequest: false,
      dataList: '',
      averange: ''
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      this.failRequest = false;

      REQUEST_SERVICE.get(GET_RATING_ONBOARDINGS).then((response) => {
        UTIL_SERVICE.console("RESULT GET_RATING_ONBOARDINGS:", response.data);

        this.averange = response.data.averange;
        this.dataList = response.data.listObject;
        this.loadingList = false;
      }).catch((reason) => {
        this.failRequest = true;
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}

.right {
  float: right;
}

.media-nps {
  display: block;
  margin-top: 20px;
  color: #3598dc !important;
  font-weight: bold;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/onboarding/listEvaluationOnboarding.vue